import { useAuth } from '@/lib/auth/auth';
import type { VenueAnalyticsOverview } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

const ANALYTICS_REFRESH_MS = 30_000;

export const venueAnalyticsOverviewKeys = {
  all: ['venue-analytics-overview'] as const,
  detail: (id: string) => [...venueAnalyticsOverviewKeys.all, id] as const,
};

export function useVenueAnalyticsOverview(id?: string | null, enabled = true) {
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: id ? venueAnalyticsOverviewKeys.detail(id) : venueAnalyticsOverviewKeys.all,
    enabled: Boolean(id) && enabled,
    queryFn: () => {
      if (!id) {
        throw new Error('Missing venue id');
      }
      return request<VenueAnalyticsOverview>(`/venues/${id}/analytics/overview`);
    },
    staleTime: ANALYTICS_REFRESH_MS,
    refetchInterval: enabled ? ANALYTICS_REFRESH_MS : false,
  });
}
